import printOnGif from "../../print_on.gif";
import { useTranslation } from "react-i18next";
import "./styles.sass";

export default function PrintButton() {
  const { t } = useTranslation();
  const handlePrint = () => {
    window.print();
  };

  return (
    <button className="print-button" onClick={handlePrint}>
      {t("PrintButton.print")}
      <img className="print-button-icon" src={printOnGif} alt="Print On" />
    </button>
  );
}
